import { render } from "./VaccineRecordComp.vue?vue&type=template&id=5dadc298"
import script from "./VaccineRecordComp.vue?vue&type=script&lang=js"
export * from "./VaccineRecordComp.vue?vue&type=script&lang=js"
script.render = render

export default script
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection});
